/* The API returns the training-data labels. Where the client's spec words a
   label differently on screen, the display name is mapped here. */
const DISPLAY_LABEL = { Overclaiming: 'Over Claiming' };

/** Why the note cannot be saved yet, shown beside the field to change. */
export default function GateReason({ gate }) {
  if (!gate) return null;
  return (
    <div className="gate-reason" role="alert">
      <span className="gate-label">{DISPLAY_LABEL[gate.label] || gate.label}</span>
      <span>{gate.reason}</span>
    </div>
  );
}
